// POS Dialogs Component
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { QRCodeSVG } from 'qrcode.react';

export function BarberDialog({
  open,
  onOpenChange,
  barbers,
  selectedBarber,
  setSelectedBarber,
  onConfirm,
  onSkip,
  isProcessing,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-800 max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-white">
            Seleccionar Barbero
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <p className="text-zinc-400 text-sm">
            Selecciona el barbero que realizó el servicio para registrar su comisión.
          </p>
          <Select value={selectedBarber} onValueChange={setSelectedBarber}>
            <SelectTrigger className="bg-zinc-800 border-zinc-700 text-white">
              <SelectValue placeholder="Seleccionar barbero" />
            </SelectTrigger>
            <SelectContent className="bg-zinc-800 border-zinc-700">
              {barbers.map((barber) => (
                <SelectItem key={barber.id} value={barber.id} className="text-white">
                  {barber.name} ({barber.commission_percentage}% comisión)
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onSkip}
              className="flex-1 border-zinc-700 text-zinc-300 hover:bg-zinc-800"
            >
              Sin barbero
            </Button>
            <Button
              onClick={onConfirm}
              disabled={!selectedBarber || isProcessing}
              className="flex-1 bg-gold text-black hover:bg-gold-dark"
              data-testid="confirm-barber-btn"
            >
              Confirmar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function QRDialog({
  open,
  onOpenChange,
  currentTime,
  qrCode,
  branchName,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-800 max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-white text-center">
            Check-in / Check-out
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center py-6">
          {/* Digital Clock */}
          <div className="mb-6 text-center">
            <p className="font-mono text-6xl text-gold font-bold tracking-wider">
              {currentTime.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
            </p>
            <p className="text-zinc-400 mt-2">
              {currentTime.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>
          
          {/* QR Code */}
          <div className="bg-white p-4 rounded-lg">
            <QRCodeSVG 
              value={qrCode || 'loading'} 
              size={200}
              level="H"
              includeMargin={true}
            />
          </div>
          
          {/* Instructions */}
          <div className="mt-6 text-center">
            <p className="text-zinc-400 text-sm">
              Los barberos deben escanear este código
            </p>
            <p className="text-zinc-400 text-sm">
              desde su app para registrar asistencia
            </p>
            <p className="text-xs text-zinc-600 mt-2">
              Sucursal: {branchName || 'N/A'}
            </p>
            <p className="text-xs text-zinc-600">
              El código se actualiza cada 4 minutos
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
